import React from "react";
import "../../styles/description/Partner.css";
import Orange from "../../assets/images/Partners/logo orange.png";
import Inwi from "../../assets/images/Partners/Logo_inwi.png";
import Attijari from "../../assets/images/Partners/Attijariwafa_bank_logo.png";
import Almandour from "../../assets/images/Partners/logo-almandour.png";
import Technoton from "../../assets/images/Partners/logo_Technoton_.webp";
import Teltonika from '../../assets/images/Partners/teltonika.svg'
import Ups from '../../assets/images/Partners/ups.png'
import Ttam from '../../assets/images/Partners/ttam.png'
import { useTranslation } from 'react-i18next'


export default function Partner(props) {
  const { t } = useTranslation();

  const partners = [
    { name : 'Orange', logo: Orange },
    { name: 'Inwi',logo: Inwi },
    { name: 'Almandour',logo: Almandour },
    { name: 'Attijari wafa bank',logo: Attijari },
    { name: 'Technoton',logo: Technoton },
    { name: 'Teltonika',logo: Teltonika },
    { name: 'Ttam',logo: Ttam },
    { name: 'Ups',logo: Ups },
  ];

  return (
    <section className="Partners--container">
      <h1 className="Partners-title">
        {t("Partners.first")} <span className="SpanHighlightBlue">{t("Partners.second")}</span>
      </h1>
      <div className="logos">
        {partners.map((L, index) => (
          <div key={index} className="slide box-logo">
            <img src={L.logo} alt={`Logo ${index}`} width={120} title={L.name} />
          </div>
        ))}
      </div>
    </section>
  );
}
